import { LanguageDistributionDto } from '@families-link/shared';
import { AnalyticsChartColorsArray } from '../../enums/analytics-chart-colors.enum';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { renderCustomizedLabel, renderCustomLegend } from '../custom-legend-label/custom-legend-label';
import { FadeSpinner } from '../../../_core/components/_ui/fade-spinner';

export const LanguagePieChart = ({ data, loading }: { data?: LanguageDistributionDto[]; loading: boolean }) => {
	const [t] = useTranslation();
	if (loading) {
		return (
			<Box sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
				<FadeSpinner size={51} height={15} width={6} borderRadius={3} />
			</Box>
		);
	}

	return (
		<Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
			<Typography sx={{ color: (theme) => theme.colors.grayLightBlue, fontSize: '16px', fontWeight: 500, pb: '12px' }}>
				Engagements Language Distribution
			</Typography>
			{data && data?.length ? (
				<Box sx={{ height: 'calc(100% - 36px)' }}>
					<ResponsiveContainer width="100%" height="100%">
						<PieChart>
							<Pie
								data={data}
								dataKey="count"
								nameKey="language"
								cx="50%"
								cy="50%"
								outerRadius="95%"
								labelLine={false}
								label={renderCustomizedLabel}
							>
								{data.map((_, index) => (
									<Cell
										// stroke={AnalyticsChartColorsArray[index % AnalyticsChartColorsArray.length]}
										key={`cell-${index}`}
										fill={AnalyticsChartColorsArray[index % AnalyticsChartColorsArray.length]}
									/>
								))}
							</Pie>
							<Tooltip />
							<Legend align="right" verticalAlign="middle" layout="vertical" content={renderCustomLegend} />
						</PieChart>
					</ResponsiveContainer>
				</Box>
			) : (
				<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
					<Typography sx={{ color: (theme) => theme.colors.grayLightBlue, fontSize: '16px', fontWeight: 500 }}>
						No data found for the chart
					</Typography>
				</Box>
			)}
		</Box>
	);
};
